var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        [
          _c(
            "vs-tabs",
            { attrs: { value: _vm.activeTab } },
            [
              _c(
                "vs-tab",
                { attrs: { label: _vm.$t("newsletter.workflow.data_basic") } },
                [_c("form-basic", { attrs: { id: _vm.id } })],
                1
              ),
              _vm.id
                ? _c(
                    "vs-tab",
                    {
                      attrs: { label: _vm.$t("newsletter.workflow.timeline") }
                    },
                    [_c("form-timeline", { attrs: { id: _vm.id } })],
                    1
                  )
                : _vm._e(),
              _vm.id
                ? _c(
                    "vs-tab",
                    {
                      attrs: {
                        label: _vm.$t("newsletter.workflow.destination")
                      }
                    },
                    [_c("form-destination", { attrs: { id: _vm.id } })],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }